import Vue from 'vue'
import VueI18n, { LocaleMessages } from 'vue-i18n'
import { getBrowserLocale } from './service/utils'

Vue.use( VueI18n )

const supportedLocales = ['en', 'de']

function loadLocaleMessages (): LocaleMessages {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages: LocaleMessages = {}

  locales.keys().forEach( key => {
    const matched = key.match( /([A-Za-z0-9-_]+)\./i )

    if ( matched && matched.length > 1 ) {
      const locale = matched[1]
      messages[locale] = locales( key )
    }
  } )
  return messages
}

function getStartingLocale() {
  const browserLocale = getBrowserLocale( { countryCodeOnly: true } )

  if ( browserLocale && supportedLocales.includes( browserLocale ) ) {
    return browserLocale
  } else {
    return process.env.VUE_APP_I18N_LOCALE || "en"
  }
}

export default new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
